import { render } from "./RadioButton.vue?vue&type=template&id=38c4a963&scoped=true"
const script = {}

import "./RadioButton.vue?vue&type=style&index=0&id=38c4a963&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38c4a963"

export default script